
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-0.453 5.666 612.453 79.334"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40.573 10.88s-.227.68-3.626 10.2c-9.52-7.933-25.84-7.253-25.84 4.987 0 14.28 34 12.467 32.867 38.307-.907 20.4-25.387 25.16-44.427 15.188 1.586-3.627 3.4-7.025 4.533-9.975 14.28 8.84 26.747 4.762 28.56-2.268C38.307 48.052-.227 53.945-.227 26.745c0-11.56 12.92-29.24 40.8-15.866zM79.787 7.707h47.374s-.226 4.08 0 9.974H91.8v20.4h25.16v9.293H91.8v25.612h35.36v9.748H79.788V7.707zM187.68 44.426h-7.706v-27.2h6.573c3.173 0 21.08-1.36 21.76 12.693.453 13.826-13.6 14.506-20.626 14.506zm.68-36.72c-4.08 0-12.92-.227-20.4-.227v75.253h11.786V54.17c2.947 0 9.067-.226 14.054-.452 6.8-.227 24.707-3.627 24.707-24.026-.227-23.12-26.067-21.76-30.148-21.985zM478.493 42.386h-7.253V17h6.12c2.945 0 18.358-.908 19.72 11.332 1.587 14.508-15.413 14.054-18.587 14.054zm25.387 40.347h14.28l-23.8-33.773c6.346-2.268 13.824-7.707 12.92-20.174-1.587-22.213-23.346-20.626-28.106-20.853-3.854-.227-12.468-.227-19.722-.227v75.027h11.787V51c3.853 0 5.212 0 11.332-.228l21.308 31.96zM301.693 37.626V8.16h11.56v74.8h-11.56V47.373H263.16V82.96H251.6V8.16h11.56v29.466M386.24 5.666c-24.025 0-39.667 17.68-39.667 39.667 0 21.986 15.642 39.667 39.44 39.667 24.025 0 39.438-17.68 39.438-39.667.23-21.986-15.41-39.667-39.21-39.667zm179.746 51.228l24.48-.228-12.467-36.946h-.227l-11.787 37.174zm5.44-48.96h13.602L612 83.186h-12.014s-2.72-7.707-6.12-17.68l-30.373.227s-1.133 3.854-4.76 17.453h-11.56l24.254-75.254z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M413.667 45.337c0 15.86-9.75 28.78-27.43 28.78-17.45 0-27.42-12.92-27.42-28.78 0-15.87 9.97-28.79 27.42-28.79 17.46 0 27.43 12.92 27.43 28.79z"}})])
          )
        }
      }
    